import { Attr, Model } from '@aclass/core/decorators/orm.decorator';
import { Model as Entity } from 'redux-orm';

export interface IPCDestinationData {
    readonly id: string;

    readonly name: string;
}

@Model({
    name: 'PCDestination'
})
export class PCDestination extends Entity<IPCDestinationData> {

    @Attr() readonly id: string;

    @Attr() readonly name: string;
}
